import { APP_ENV } from "../Constants/common";

const validEnvironments = ["local", "staging", "development"];

const getCallerInfo = () => {
  const error = new Error();
  const stack = error.stack.split("\n");

  // Parse the stack trace to extract the relevant caller info
  // Stack trace format varies across browsers and environments
  const callerLine = stack[3]; // 3rd index usually contains the caller information
  const callerInfo = callerLine.match(/\((.*)\)/);

  if (callerInfo) {
    return callerInfo[1]; // This will return the file name and line number
  }
  return "unknown location";
};

const log = (...message) => {
  if (validEnvironments.includes(APP_ENV)) {
    const callerInfo = getCallerInfo();
    console.log(...message, `\n\n ${callerInfo}`);
    // console.log(`LOG: ${message}`);
  }
};

const warn = (...message) => {
  if (validEnvironments.includes(APP_ENV)) {
    const callerInfo = getCallerInfo();
    console.warn(...message, `\n\n ${callerInfo}`);
    // console.warn(`WARNING: ${...message}`);
  }
};

const error = (...message) => {
  // Always log errors regardless of environment
  if (validEnvironments.includes(APP_ENV)) {
    const callerInfo = getCallerInfo();
    console.error(...message, `\n\n ${callerInfo}`);
    // console.error(`ERROR: ${...message}`);
  }
};

const logger = { log, warn, error };
window._logger = logger;

export default logger;
